export function useAdvTextColor(currentAdv: number, advValue: number) {
  if (currentAdv === advValue) {
    return 'text-[#f00] underline';
  } else {
    return 'text-[#00f]';
  }
}
